import { render } from "./VideoContentB.vue?vue&type=template&id=2985fc2a&scoped=true"
import script from "./VideoContentB.vue?vue&type=script&lang=js"
export * from "./VideoContentB.vue?vue&type=script&lang=js"

import "./VideoContentB.vue?vue&type=style&index=0&id=2985fc2a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2985fc2a"]])

export default __exports__